import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { logout, setAuthData } from "./authSlice";

interface ConversationsUnreadState {
  count: number;
  frozenCount: number | null;
  userUid: string | null;
}

const initialState: ConversationsUnreadState = {
  count: 0,
  frozenCount: null,
  userUid: null,
};

export const conversationsUnreadSlice = createSlice({
  name: "conversationsUnread",
  initialState,
  reducers: {
    setUnreadCount: (state, action: PayloadAction<number>) => {
      state.count = action.payload;
    },
    freezeUnreadCount: (state, action: PayloadAction<number>) => {
      if (state.frozenCount === null) state.frozenCount = action.payload;
    },
    resetFrozenUnreadCount: (state) => {
      state.frozenCount = null;
    },
    markConversationsRead: (state) => {
      state.count = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logout, () => initialState)
      .addCase(setAuthData, (state, action) => {
        const uid = action.payload.user?.uid ?? null;
        if (state.userUid === uid) return state;
        return { ...initialState, userUid: uid };
      });
  },
});

export const { setUnreadCount, freezeUnreadCount, resetFrozenUnreadCount, markConversationsRead } =
  conversationsUnreadSlice.actions;

export default conversationsUnreadSlice.reducer;
